var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-selection-page", on: { click: _vm.close } },
    [
      _c(
        "div",
        {
          staticClass: "email-page-container",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("p", { staticClass: "close-bulk", on: { click: _vm.close } }, [
            _vm._v("< back to select gifts")
          ]),
          _vm._v(" "),
          _vm.step == 1
            ? _c("EmailSelection", {
                attrs: { product: _vm.product },
                on: {
                  next: function($event) {
                    return _vm.next($event)
                  }
                }
              })
            : _c("EmailConfiguration", {
                attrs: { product: _vm.product, emailFile: _vm.emailFile },
                on: {
                  end: _vm.end,
                  next: function($event) {
                    return _vm.next($event)
                  }
                }
              })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }